import { Theme } from '@src/styled-components';
import { Col, Row } from 'antd';
import * as React from 'react';

import styled from '../../../../../../node_modules/styled-components';

interface Iprop {
    info: any[]
}

export default class HistoryItemExtraInfo extends React.Component<Iprop, {}> {

    putVals () {
        const { info } = this.props;
        const vals = []
        for (let i of info) {
            vals.push(<Row key={i.label}>
                <div className="wrap">
                    <h3 className="extra-info-title">{i.label}</h3>
                </div>
                {!i.isArray && i.value && (
                    <div className="extra-info-data">{i.description}</div>
                )}
            </Row>)
        }
        return (
            <div>{vals}</div>
        )

    }

    renderInfo () {

        const { info } = this.props;

        if (info && info.length > 0) {
            return (

                <div>
                    {this.putVals()}
                </div>
            )
        }
        return;
    }


    render () {
        return (
            <GoEpikHistoryHeader>
                <Row className="goepik-side-padding">
                    <Col sm={24} md={24} xl={24}>
                        <Row>
                            <Col sm={24} md={24} xl={24}>
                                <Row>
                                    <Col sm={24} md={18} xl={18} >
                                        {this.renderInfo()}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </GoEpikHistoryHeader>
        );
    }
};

const GoEpikHistoryHeader = styled.div`
    .goepik-history-header-title{
        font-weight:200;
    }
    .goepik-side-padding{
        padding-left: 24px!important;
        padding-right: 24px!important;
    }
    h2{
        font-size:20px;
        font-weight:bold;
    }
    .goepik-text-center{
        text-align: center;
    }

    .goepik-risk-red{
        color: ${Theme.standard.red || '#f3f3f3'};
        font-size:20px;
    }
    .goepik-risk-yellow{
        color: ${Theme.standard.orange || '#f3f3f3'};
        font-size:20px;
    }
    .goepik-risk-green{
        color: ${Theme.standard.green || '#f3f3f3'};
        font-size:20px;
    }
    
    .extra-info-title{        
        font-weight:bold;
        font-size: 18px;
        margin-bottom: 6px;
    }
    .extra-info-data{
        font-size: 16px;
        margin-bottom: 6px;
        font-weight: bold;
        color: ${Theme.standard.orange || '#f3f3f3'};
    }
`;
